import { UIComponent } from '@/components/core/components';
import { Trans } from '@lingui/react/macro';
import * as styles from './multiplatform.styles';

const Multiplatform: UIComponent = () => {
  return (
    <section className={styles.root}>
      <h2 className={styles.title}>
        <Trans>💰 Monetization across multiple platforms</Trans>
      </h2>
      <p className={styles.subtitle}>
        <Trans>
          Monetize your content and turn your passion into income with Peoople. Share on the platform and generate earnings through different digital
          channels.
        </Trans>
      </p>
      <div className={styles.images}>
        <span>
          <img src="/home/blog.png" alt="Blog" />
          <Trans>Blogs</Trans>
        </span>
        <span>
          <img src="/home/rrss.png" alt="Blog" />
          <Trans>Social networks</Trans>
        </span>
        <span>
          <img src="/home/newsletter.png" alt="Blog" />
          <Trans>Newsletters</Trans>
        </span>
        <span>
          <img src="/home/podcast.png" alt="Blog" />
          <Trans>Podcasts</Trans>
        </span>
        <span>
          <img src="/home/subscription.png" alt="Blog" />
          <Trans>Subscriptions</Trans>
        </span>
      </div>
    </section>
  );
};

export default Multiplatform;
